import getDateFilterFn from '@/utils/get-date-filter-fn'
import store from '@/store'

export default (dateFilterKey) => {
  const dateFilterSettingsList = store.state.DateFilterSettings.dateFilterSettings
  const dateFilter = dateFilterSettingsList.find(df => df.key === dateFilterKey)
  return getDateFilterFn(dateFilter)
}
